<template>
    <div>
        <add-edit-user v-if="isAddEditUserOpened" />
        <add-edit-team v-if="isAddEditTeamOpened" />
    </div>
</template>

<script>
export default {
    name: 'AppModals',
    components: {
        AddEditUser: () => import('@/views/Users/AddEditUser'),
        AddEditTeam: () => import('@/views/Teams/AddEditTeam'),
    },
    computed: {
        isAddEditUserOpened () {
            return this.$store.getters['modals/isOpened']('addEditUser')
        },
        isAddEditTeamOpened () {
            return this.$store.getters['modals/isOpened']('addEditTeam')
        },
    },
}
</script>
